import { publishedTimestampLabel } from '@/Helpers.js';
import Model from '@/models/Model.js';
import ReadReceipt from '@/models/ReadReceipt.js';
import axios from '@/plugins/axios.js';

export default class ActivityUpdate extends Model {
    static entity = 'activity_updates';

    static modelName = 'ActivityUpdate';

    static fields() {
        return {
            alertType: this.string('Activity Update'),
            activity_id: this.attr(null),
            body: this.attr(null),
            safe_body: this.attr(null),
            course_id: this.attr(null),
            id: this.attr(null),
            media: this.attr(null),
            published_at: this.attr(null),
            title: this.attr(null),
            important: this.attr(null),
            read: this.attr(null),

            ...super.fields(),

            course: this.belongsTo('courses', 'course_id'),
            creator: this.belongsTo('users', 'created_by'),
            activity: this.belongsTo('activities', 'activity_id'),
            read_receipts: this.morphMany('read_receipts', 'readable_id', 'readable_type_entity'),
        };
    }

    get backend_class() {
        return 'App\\Models\\ActivityUpdate';
    }

    get router_link() {
        return {
            name: 'course-dashboard', // Change to activity page
            params: { courseId: this.course_id },
        };
    }

    get published_label() {
        return publishedTimestampLabel(this.timestamp('published_at'));
    }

    get marked_as_read() {
        const userId = Model.store().getters['Auth/userId'];

        if (userId === this.created_by) {
            return true;
        }

        const modelType = 'App\\Models\\ActivityUpdate';

        return ReadReceipt.query()
            .where('readable_id', this.id)
            .where('readable_type', modelType)
            .where('user_id', userId)
            .exists();
    }

    markAsRead() {
        return ReadReceipt.api().put('/api/mark-as-read', {
            readable_id: this.id,
            readable_type: 'App\\Models\\ActivityUpdate',
        });
    }

    async markAsUnread() {
        const response = await axios.put('/api/mark-as-unread', {
            readable_id: this.id,
            readable_type: 'App\\Models\\ActivityUpdate',
        });

        ReadReceipt.query()
            .where('readable_id', this.id)
            .where('readable_type', 'App\\Models\\ActivityUpdate')
            .where('user_id', ActivityUpdate.store().getters['Auth/userId'])
            .get()
            .forEach(readReceipt => readReceipt.$delete());

        return response;
    }

    get formatted_created_at() {
        return this.timestamp('created_at').format('MM/DD/YYYY - h:mm a');
    }

    /**
     * Absolute publish date for the announcement popup, matching
     * `CourseAnnouncement.published_date_label` ("Oct 21, 2026 at 10:45 AM").
     * `timestamp()` falls back to the default timezone when none is configured.
     */
    get published_date_label() {
        return this.timestamp('published_at').format('MMM D, YYYY [at] h:mm A');
    }
}
